import axios from 'axios';
import ValidateConstructor from '@smarterservices/iam-react-client';
import SessionStore from './stores/SessionStore';

// Helpers
import { getCookie } from './helpers/helpers';

export let config = {
  apiUrl: 'http://localhost:8011/v1',
  // apiUrl: 'https://api.dev.smarterproctoring.com/v1',
  schUrl: 'http://localhost:8013/v1',
  domain: 'http://localhost:3002',
  mapsApiKey: 'AIzaSyBXUGDThYYVJOIcfKhKiUCbkQJz8LDVvXg',
  ldApiKey: '59edfdfd082f980b153ac148',
  logRocket: 'bkdp5p/proctor-ui-production',
  testingCenterSid: 'TC180270c80a324de68af4ac8c5a151423',
  testingAdministratorSid: 'TSc8a267352ced49f1886db9ad972ec797',
  generalPublicSid: 'TSf2372716b074429a8253af78afd3d51c',
  onlineLocationSid: 'LT6ed9000faf944bfbb7af4924a3068fc1',
  coffeeShopSid: 'LT25c1697388414af2a73cc7dd25e49abb',
  docsDomain: 'https://smarterproctoring.zendesk.com/hc/en-us/',
  defaultTimeZoneSid: 'TZ356c0b38525c4d94a1b60e76ded97066',
  gaProctor: 'UA-42156997-3',
  hybridDomain: 'http://localhost:3009',
  hybridBetaDomain: 'http://localhost:3009',
  hybridAlphaDomain: 'http://localhost:3009',
  schedulingDomain: 'https://proctor.scheduling.dev.smarterproctoring.com',
  checkoutUrlBase: 'https://support.dev.smarterservices.com/index.cfm?action=hybridCheckout'
}

if(process.env.REACT_APP_ENVIRONMENT === 'production' || process.env.REACT_APP_ENVIRONMENT === 'production-b') {
  config.apiUrl = process.env.REACT_APP_ENVIRONMENT === 'production' ? 'https://api.smarterproctoring.com/v1' : 'https://api-b.smarterproctoring.com/v1';
  config.schUrl = 'https://scheduling.smarterproctoring.com/v1';
  config.domain = process.env.REACT_APP_ENVIRONMENT === 'production' ? 'https://app.smarterproctoring.com' : 'https://app-b.smarterproctoring.com';
  config.ldApiKey = '55b25a2f133767270f000092';
  config.testingCenterSid = 'TCd350ab0c17b846f799b51f15f684e77c';
  config.testingAdministratorSid = 'TSde44f39d587d4acc8d6c3fc8a8aa7282';
  config.generalPublicSid = 'TSf2372716b074429a8253af78afd3d51c';
  config.onlineLocationSid = 'LT07b8055c8a9c457c82c58b235a05d53b';
  config.coffeeShopSid = 'LT1fef2992eda74744a432dc963c9877ed';
  config.defaultTimeZoneSid = 'TZ87effa3d827b480ba4919ef38175fe5f';
  config.hybridDomain = 'https://hybrid.smarterproctoring.com';
  config.hybridBetaDomain = 'https://hybrid.beta.smarterproctoring.com';
  config.hybridAlphaDomain = 'https://hybrid.alpha.smarterproctoring.com';
  config.schedulingDomain = 'https://proctor.scheduling.smarterproctoring.com';
  config.checkoutUrlBase = 'https://support.smarterservices.com/index.cfm?action=hybridCheckout';
}

if(process.env.REACT_APP_ENVIRONMENT === 'qa') {
  config.apiUrl = 'https://api-qa.smarterproctoring.com/v1';
  config.schUrl = 'https://scheduling.smarterproctoring.com/v1';
  config.domain = 'https://app-qa.smarterproctoring.com';
  config.ldApiKey = '55b25a2f133767270f000092';
  config.testingCenterSid = 'TCd350ab0c17b846f799b51f15f684e77c';
  config.testingAdministratorSid = 'TSde44f39d587d4acc8d6c3fc8a8aa7282';
  config.generalPublicSid = 'TSf2372716b074429a8253af78afd3d51c';
  config.onlineLocationSid = 'LT07b8055c8a9c457c82c58b235a05d53b';
  config.coffeeShopSid = 'LT1fef2992eda74744a432dc963c9877ed';
  config.defaultTimeZoneSid = 'TZ87effa3d827b480ba4919ef38175fe5f';
  config.hybridDomain = 'https://hybrid-qa.smarterproctoring.com';
  config.hybridBetaDomain = 'https://hybrid-qa.smarterproctoring.com';
  config.hybridAlphaDomain = 'https://hybrid-qa.smarterproctoring.com';
}

if(process.env.REACT_APP_ENVIRONMENT === 'local') {
  config.apiUrl = 'http://localhost:8011/v1';
  config.schUrl = 'https://scheduling-stage.smarterproctoring.com/v1';
  config.domain = 'http://localhost:3002';
  config.hybridDomain = 'http://localhost:3009';
  config.schedulingDomain = 'http://localhost:8017';
}

if(process.env.REACT_APP_ENVIRONMENT === 'stage') {
  config.apiUrl = 'https://api-stage.smarterproctoring.com/v1';
  config.schUrl = 'https://scheduling-stage.smarterproctoring.com/v1';
  config.domain = 'https://stage.smarterproctoring.com';
  config.hybridDomain = 'https://hybrid-stage.smarterproctoring.com';
  config.hybridBetaDomain = 'https://hybrid-stage.smarterproctoring.com';
  config.hybridAlphaDomain = 'https://hybrid-stage.smarterproctoring.com';
  config.schedulingDomain = 'https://proctor.scheduling.stage.smarterproctoring.com';
}

if(process.env.REACT_APP_ENVIRONMENT === 'dev') {
  config.apiUrl = 'https://api.dev.smarterproctoring.com/v1';
  config.schUrl = 'https://scheduling.dev.smarterproctoring.com/v1';
  config.domain = 'https://dev.smarterproctoring.com';
  config.hybridDomain = 'https://hybrid.dev.smarterproctoring.com';
  config.hybridBetaDomain = 'https://hybrid.dev.smarterproctoring.com';
  config.hybridAlphaDomain = 'https://hybrid.dev.smarterproctoring.com';
  config.schedulingDomain = 'https://proctor.scheduling.dev.smarterproctoring.com';
}

if(process.env.REACT_APP_ENVIRONMENT === 'sub') {
  config.apiUrl = 'https://api.sub.smarterproctoring.com/v1';
  config.schUrl = 'https://scheduling-stage.smarterproctoring.com/v1';
  config.domain = 'https://sub.smarterproctoring.com';
  config.hybridDomain = 'https://hybrid.sub.smarterproctoring.com';
  config.hybridBetaDomain = 'https://hybrid.sub.smarterproctoring.com';
  config.hybridAlphaDomain = 'https://hybrid.sub.smarterproctoring.com';
  config.schedulingDomain = 'https://proctor.scheduling.dev.smarterproctoring.com';
}

export let api = axios.create({
  baseURL: config.apiUrl
});

export let schApi = axios.create({
  baseURL: config.schedulingUrl
});


export function setToken(token, callback) {
  api = axios.create({
    baseURL: config.apiUrl,
    headers: { token }
  });

  schApi = axios.create({
    baseURL: config.schUrl,
    headers: { token }
  });

  if(token && callback) {
    setTimeout(function(){
      callback();
    });
  }
}


export let Validate = null;


if(SessionStore && SessionStore.hasSessionStorage) {
  Validate = new ValidateConstructor({iam: JSON.parse(sessionStorage.getItem('iam'))});
} else {
  try {
    Validate = new ValidateConstructor({iam: JSON.parse(getCookie('iam'))});
  } catch (err) {
    Validate = new ValidateConstructor({iam: undefined});
  }
}

export function setValidate() {
  if(SessionStore.hasSessionStorage) {
    Validate = new ValidateConstructor({iam: JSON.parse(sessionStorage.getItem('iam'))});
  } else {
    try {
    Validate = new ValidateConstructor({iam: JSON.parse(getCookie('iam'))});
    } catch (err) {
      Validate = new ValidateConstructor({iam: undefined})
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/config.js